import React from "react";

const BriefScheduleDetail = ({ data }) => {
	return (
		<div className="card">
			<div className="card-header">Informasi Soal</div>
			<div className="card-block">
				<div className="form-horizontal animated fadeIn">
					<div className="form-group row">
						<label className="col-md-2 form-control-label">Nama Kategori</label>
						<div className="col-md-10">
							{data.examkat !== null ? data.examkat.exam_cat_name : "-"}
						</div>
					</div>
					<div className="form-group row">
						<label className="col-md-2 form-control-label">
							Mata Pelajaran
						</label>
						<div className="col-md-10">{data.mapel.mapel_nama}</div>
					</div>
					<div className="form-group row">
						<label className="col-md-2 form-control-label">Nama Guru</label>
						<div className="col-md-10">{data.user.user_nama}</div>
					</div>
					<div className="form-group row">
						<label className="col-md-2 form-control-label">Nama Soal</label>
						<div className="col-md-10">{data.exam_title}</div>
					</div>
					<div className="form-group row">
						<label className="col-md-2 form-control-label">Tanggal Ujian</label>
						<div className="col-md-10">{`${data.exam_start_date} - ${
							data.exam_end_date
						}`}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BriefScheduleDetail;



// WEBPACK FOOTER //
// ./src/views/Exam/Question/BriefScheduleDetail.js